import {connect} from 'react-redux';

import {loadResourceTags} from '../../../../../state/modules/resourceTags/actions';
import TagInput from '../components/TagInput';

const mapStateToProps = (state) => {
  const tags = state.entities.get('resourceTags', {});
  return {
    options: Object.keys(tags)
      .map(id => {return {label: tags[id].label, value: tags[id].label}}),
    isLoading: state.resourceTags.get('isLoading'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadResourceTags(page, limit, order, filter, cb));
    },
  }
}

const TagInputContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TagInput);

export default TagInputContainer;
